/** 확인사항 → SafetyWorkManagement 시 URL 없이 탭 지정(history state 유실 대비) */
export const SAM_INITIAL_TAB_SESSION_KEY = 'safeon_sam_initial_tab_v1';

export function StashSamInitialTabInSession(tabIndex) {
  try {
    sessionStorage.setItem(SAM_INITIAL_TAB_SESSION_KEY, String(tabIndex));
  } catch (_) {
    /* private mode 등 */
  }
}

export function ReadSamInitialTabFromSession() {
  try {
    const v = sessionStorage.getItem(SAM_INITIAL_TAB_SESSION_KEY);
    if (v === '1') return 1;
    if (v === '0') return 0;
  } catch (_) {
    /* ignore */
  }
  return null;
}

/** React Strict Mode 이중 마운트 대비 — 초기화 직후 바로 지우지 않고 지연 제거 */
export function ScheduleClearSamInitialTabSession() {
  return window.setTimeout(() => {
    try {
      sessionStorage.removeItem(SAM_INITIAL_TAB_SESSION_KEY);
    } catch (_) {
      /* ignore */
    }
  }, 400);
}
